import React from 'react'
import createSvgIcon from '../utilities/createSvgIcon'

export default createSvgIcon(
  <path d="M20 6H16V4C16 2.89 15.11 2 14 2H10C8.89 2 8 2.89 8 4V6H4C2.89 6 2.01 6.89 2.01 8L2 19C2 20.11 2.89 21 4 21H20C21.11 21 22 20.11 22 19H17V16H14V10H17V7H21.735C21.3908 6.40084 20.7449 6 20 6ZM14 6H10V4H14V6Z M21 9V12H24V14H21V17H19V14H16V12H19V9H21Z" />,
  'AddToWorkflow',
)
